import { render } from "./simpleCalendar.vue?vue&type=template&id=b4236cdc&scoped=true"
import script from "./simpleCalendar.vue?vue&type=script&lang=js"
export * from "./simpleCalendar.vue?vue&type=script&lang=js"

import "./simpleCalendar.vue?vue&type=style&index=0&id=b4236cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4236cdc"]])

export default __exports__